import { lazy, Suspense, useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"

import { Card, Flex, LogoImage, message, Text } from "@/atoms"
import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { RegionDropdown } from "@/pages/SignInPage/components/molecules/RegionDropdown"

const SelfHostingMetaData = lazy(
  () => import("@/molecules/SelfHostingMetaData")
)

import styles from "./SignInPageTemplate.module.scss"

type SignInPageTemplateProps = {
  showRegion?: boolean
}

export const SignInPageTemplate = ({
  showRegion = true
}: SignInPageTemplateProps = {}) => {
  const [messageApi, contextHolder] = message.useMessage()
  const { state } = useLocation()
  const { successMessage } = state || {}

  useEffect(() => {
    if (successMessage) {
      messageApi.success(successMessage)
    }
  }, [successMessage, messageApi])

  return (
    <div className={styles.containerSignInPageTemplate}>
      {contextHolder}
      {showRegion && (
        <Flex justify="flex-end" className={styles.region}>
          <RegionDropdown />
        </Flex>
      )}
      <div className={styles.logo}>
        <LogoImage height={60} />
      </div>
      <Card id="outlet-card-signin-template" className={styles.card}>
        <Outlet />
      </Card>
      <div className={styles.footer}>
        {isSelfHosted() && (
          <Suspense>
            <SelfHostingMetaData space />
          </Suspense>
        )}
        <Text type="secondary">
          Kodem Security &#169;2022-{new Date().getFullYear()}
        </Text>
      </div>
    </div>
  )
}
